import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setSearchOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/romance', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className={`font-heading text-2xl font-bold transition-colors duration-400 ${
              scrolled ? 'text-foreground-950' : 'text-background-50'
            }`}>
              韩漫之家
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-background-50/90 hover:text-background-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
                scrolled
                  ? 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
                  : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/category/romance"
              className={`px-5 py-2 rounded-full text-sm font-medium border transition-all duration-300 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'border-primary-500 text-primary-600 hover:bg-primary-500 hover:text-background-50'
                  : 'border-background-50/50 text-background-50 hover:bg-background-50 hover:text-foreground-950'
              }`}
            >
              开始阅读
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full cursor-pointer ${
              scrolled ? 'text-foreground-700' : 'text-background-50'
            }`}
          >
            <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {searchOpen && (
          <div className="hidden md:block pb-3">
            <div className="relative max-w-md mx-auto">
              <input
                type="text"
                placeholder="搜索漫画名称、作者..."
                className="w-full px-4 py-2.5 pl-10 rounded-full bg-background-100 text-sm text-foreground-900 placeholder:text-foreground-400 border border-background-200 focus:border-primary-400 focus:outline-none transition-colors"
              />
              <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>
        )}
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm text-foreground-700 hover:text-primary-500 py-2 transition-colors cursor-pointer"
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-2">
              <input
                type="text"
                placeholder="搜索漫画名称、作者..."
                className="w-full px-4 py-2.5 pl-10 rounded-full bg-background-100 text-sm text-foreground-900 placeholder:text-foreground-400 border border-background-200 focus:border-primary-400 focus:outline-none transition-colors"
              />
            </div>
            <Link
              to="/category/romance"
              className="text-center px-5 py-2.5 rounded-full text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}